/* eslint-disable */
// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.5
// Generated from `ActFinalMatchStruct.jce'
// **********************************************************************

var ActFinalMatch = ActFinalMatch || {};


ActFinalMatch.TemplateURI =
{
  PushAnchorPanel: 20191201,
  PushAnchorUpdate: 20191202,
  PushHourRank: 20191203,
  PushStageRank: 20191204,
  PushMasterRank: 20191205,
  PushBattleAnnouncePanel: 20191208,
  PushBattlePanel: 20191209,
  PushContributionRank: 20191210,
  PushBattleUpdatePanel: 20191211,
  PushBattleResultPanel: 20191212,
  PushPromoteResultPanel: 20191213,
  PushHonorResultPanel: 20191214,
  PushBattleAssistRank: 20191215,
  PushClearPanel: 20191299,
};

ActFinalMatch.STAGE1 =
{
  kNFBeforeActivityStage: 0,
  kNFStageTop32: 1,
  kNFStageTop16: 2,
  kNFStageTop10: 3,
  kNFStageTop5: 4,
  kNFStageTop1: 5,
  kNfHonorStage: 6,
};

ActFinalMatch.STAGE2 =
{
  kGEBeforeActivityStage: 0,
  kGEStageTop20: 1,
  kGEStageTop15: 2,
  kGEStageTop10: 3,
  kGEStageTop8: 4,
  kGEStageTop5: 5,
  kGEStageTop1: 6,
  kGEHonorStage: 7,
};

ActFinalMatch.PromoteType =
{
  PT_Promote: 1,
  PT_Eliminate: 2,
};

ActFinalMatch.HourTheme =
{
  HT_SuperFans: 1,
  HT_SuperTicket: 2,
  HT_AnnulaTicket: 3,
  HT_PK: 4,
};

ActFinalMatch.AreaType =
{
  AREA_NF_Game: 1,
  AREA_NF_Ent: 2,
  AREA_NF_Jy: 3,
  AREA_GE_Game: 4,
  AREA_GE_Ent: 5,
  AREA_GE_Jy: 6,
};

ActFinalMatch.JumpChannel = function () {
  this.lPid = 0;
  this.lTid = 0;
  this.lSid = 0;
  this.iGameId = 0;
  this.lYYId = 0;
  this.iRoomId = 0;
};
ActFinalMatch.JumpChannel.prototype._clone = function () {
  return new ActFinalMatch.JumpChannel();
}
ActFinalMatch.JumpChannel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.JumpChannel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.JumpChannel.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeInt64(1, this.lTid);
  os.writeInt64(2, this.lSid);
  os.writeInt32(3, this.iGameId);
  os.writeInt64(4, this.lYYId);
  os.writeInt32(5, this.iRoomId);
};

ActFinalMatch.JumpChannel.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.lTid = is.readInt64(1, false, this.lTid);
  this.lSid = is.readInt64(2, false, this.lSid);
  this.iGameId = is.readInt32(3, false, this.iGameId);
  this.lYYId = is.readInt64(4, false, this.lYYId);
  this.iRoomId = is.readInt32(5, false, this.iRoomId);
};

ActFinalMatch.PresenterBase = function () {
  this.lPid = 0;
  this.sNickName = '';
  this.sLogoUrl = '';
  this.sPortait = '';
  this.sBriefText = '';
};
ActFinalMatch.PresenterBase.prototype._clone = function () {
  return new ActFinalMatch.PresenterBase();
}
ActFinalMatch.PresenterBase.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.PresenterBase.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.PresenterBase.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeString(1, this.sNickName);
  os.writeString(2, this.sLogoUrl);
  os.writeString(3, this.sPortait);
  os.writeString(4, this.sBriefText);
};

ActFinalMatch.PresenterBase.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.sNickName = is.readString(1, false, this.sNickName);
  this.sLogoUrl = is.readString(2, false, this.sLogoUrl);
  this.sPortait = is.readString(3, false, this.sPortait);
  this.sBriefText = is.readString(4, false, this.sBriefText);
};

ActFinalMatch.AnchorUpdate = function () {
  this.lPid = 0;
  this.iTaskLv = 0;
  this.iTaskProgress = 0;
  this.iTaskRequire = 0;
  this.iTaskReward = 0;
  this.iTaskFinish = 0;
  this.iRank = 0;
  this.lScore = 0;
  this.iHourRank = 0;
  this.lHourScore = 0;
  this.iBuff = 0;
  this.iHourTheme = 0;
  this.iPromoteLimit = 0;
  this.iTriggerLimit = 0;
};
ActFinalMatch.AnchorUpdate.prototype._clone = function () {
  return new ActFinalMatch.AnchorUpdate();
}
ActFinalMatch.AnchorUpdate.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.AnchorUpdate.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.AnchorUpdate.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeInt32(1, this.iTaskLv);
  os.writeInt32(2, this.iTaskProgress);
  os.writeInt32(3, this.iTaskRequire);
  os.writeInt32(4, this.iTaskReward);
  os.writeInt32(5, this.iTaskFinish);
  os.writeInt32(6, this.iRank);
  os.writeInt64(7, this.lScore);
  os.writeInt32(8, this.iHourRank);
  os.writeInt64(9, this.lHourScore);
  os.writeInt32(10, this.iBuff);
  os.writeInt32(11, this.iHourTheme);
  os.writeInt32(12, this.iPromoteLimit);
  os.writeInt32(13, this.iTriggerLimit);
};

ActFinalMatch.AnchorUpdate.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.iTaskLv = is.readInt32(1, false, this.iTaskLv);
  this.iTaskProgress = is.readInt32(2, false, this.iTaskProgress);
  this.iTaskRequire = is.readInt32(3, false, this.iTaskRequire);
  this.iTaskReward = is.readInt32(4, false, this.iTaskReward);
  this.iTaskFinish = is.readInt32(5, false, this.iTaskFinish);
  this.iRank = is.readInt32(6, false, this.iRank);
  this.lScore = is.readInt64(7, false, this.lScore);
  this.iHourRank = is.readInt32(8, false, this.iHourRank);
  this.lHourScore = is.readInt64(9, false, this.lHourScore);
  this.iBuff = is.readInt32(10, false, this.iBuff);
  this.iHourTheme = is.readInt32(11, false, this.iHourTheme);
  this.iPromoteLimit = is.readInt32(12, false, this.iPromoteLimit);
  this.iTriggerLimit = is.readInt32(13, false, this.iTriggerLimit);
};

ActFinalMatch.AnchorPanel = function () {
  this.tUpdate = new ActFinalMatch.AnchorUpdate();
  this.iCurDay = 0;
  this.iMaxDay = 0;
  this.iStage = 0;
  this.sStageName = '';
  this.iArea = 0;
  this.sAreaName = '';
  this.tPresenter = new ActFinalMatch.PresenterBase();
  this.iLogoType = 0;
};
ActFinalMatch.AnchorPanel.prototype._clone = function () {
  return new ActFinalMatch.AnchorPanel();
}
ActFinalMatch.AnchorPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.AnchorPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.AnchorPanel.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tUpdate);
  os.writeInt32(1, this.iCurDay);
  os.writeInt32(2, this.iMaxDay);
  os.writeInt32(3, this.iStage);
  os.writeString(4, this.sStageName);
  os.writeInt32(5, this.iArea);
  os.writeString(6, this.sAreaName);
  os.writeStruct(7, this.tPresenter);
  os.writeInt32(8, this.iLogoType);
};

ActFinalMatch.AnchorPanel.prototype.readFrom = function (is) {
  this.tUpdate = is.readStruct(0, false, this.tUpdate);
  this.iCurDay = is.readInt32(1, false, this.iCurDay);
  this.iMaxDay = is.readInt32(2, false, this.iMaxDay);
  this.iStage = is.readInt32(3, false, this.iStage);
  this.sStageName = is.readString(4, false, this.sStageName);
  this.iArea = is.readInt32(5, false, this.iArea);
  this.sAreaName = is.readString(6, false, this.sAreaName);
  this.tPresenter = is.readStruct(7, false, this.tPresenter);
  this.iLogoType = is.readInt32(8, false, this.iLogoType);
};

ActFinalMatch.RankItem = function () {
  this.tJump = new ActFinalMatch.JumpChannel();
  this.tPresenter = new ActFinalMatch.PresenterBase();
  this.iRank = 0;
  this.lScore = 0;
};
ActFinalMatch.RankItem.prototype._clone = function () {
  return new ActFinalMatch.RankItem();
}
ActFinalMatch.RankItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.RankItem.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.RankItem.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tJump);
  os.writeStruct(1, this.tPresenter);
  os.writeInt32(2, this.iRank);
  os.writeInt64(3, this.lScore);
};

ActFinalMatch.RankItem.prototype.readFrom = function (is) {
  this.tJump = is.readStruct(0, false, this.tJump);
  this.tPresenter = is.readStruct(1, false, this.tPresenter);
  this.iRank = is.readInt32(2, false, this.iRank);
  this.lScore = is.readInt64(3, false, this.lScore);
};

ActFinalMatch.MasterRankItem = function () {
  this.lUid = 0;
  this.iRank = 0;
  this.lScore = 0;
  this.sNickName = '';
  this.sLogoUrl = '';
  this.iLabel = 0;
};
ActFinalMatch.MasterRankItem.prototype._clone = function () {
  return new ActFinalMatch.MasterRankItem();
}
ActFinalMatch.MasterRankItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.MasterRankItem.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.MasterRankItem.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeInt32(1, this.iRank);
  os.writeInt64(2, this.lScore);
  os.writeString(3, this.sNickName);
  os.writeString(4, this.sLogoUrl);
  os.writeInt32(5, this.iLabel);
};

ActFinalMatch.MasterRankItem.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.iRank = is.readInt32(1, false, this.iRank);
  this.lScore = is.readInt64(2, false, this.lScore);
  this.sNickName = is.readString(3, false, this.sNickName);
  this.sLogoUrl = is.readString(4, false, this.sLogoUrl);
  this.iLabel = is.readInt32(5, false, this.iLabel);
};

ActFinalMatch.HourRankPanel = function () {
  this.iBegHour = 0;
  this.iEndHour = 0;
  this.vRankList = new Taf.Vector(new ActFinalMatch.RankItem());
  this.iHourTheme = 0;
};
ActFinalMatch.HourRankPanel.prototype._clone = function () {
  return new ActFinalMatch.HourRankPanel();
}
ActFinalMatch.HourRankPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.HourRankPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.HourRankPanel.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iBegHour);
  os.writeInt32(1, this.iEndHour);
  os.writeVector(2, this.vRankList);
  os.writeInt32(3, this.iHourTheme);
};

ActFinalMatch.HourRankPanel.prototype.readFrom = function (is) {
  this.iBegHour = is.readInt32(0, false, this.iBegHour);
  this.iEndHour = is.readInt32(1, false, this.iEndHour);
  this.vRankList = is.readVector(2, false, this.vRankList);
  this.iHourTheme = is.readInt32(3, false, this.iHourTheme);
};

ActFinalMatch.StageRankPanel = function () {
  this.iArea = 0;
  this.vRankList = new Taf.Vector(new ActFinalMatch.RankItem());
};
ActFinalMatch.StageRankPanel.prototype._clone = function () {
  return new ActFinalMatch.StageRankPanel();
}
ActFinalMatch.StageRankPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.StageRankPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.StageRankPanel.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iArea);
  os.writeVector(1, this.vRankList);
};

ActFinalMatch.StageRankPanel.prototype.readFrom = function (is) {
  this.iArea = is.readInt32(0, false, this.iArea);
  this.vRankList = is.readVector(1, false, this.vRankList);
};

ActFinalMatch.MasterRankPanel = function () {
  this.vRankList = new Taf.Vector(new ActFinalMatch.MasterRankItem());
};
ActFinalMatch.MasterRankPanel.prototype._clone = function () {
  return new ActFinalMatch.MasterRankPanel();
}
ActFinalMatch.MasterRankPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.MasterRankPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.MasterRankPanel.prototype.writeTo = function (os) {
  os.writeVector(0, this.vRankList);
};

ActFinalMatch.MasterRankPanel.prototype.readFrom = function (is) {
  this.vRankList = is.readVector(0, false, this.vRankList);
};

ActFinalMatch.PromotePresenter = function () {
  this.tJump = new ActFinalMatch.JumpChannel();
  this.tPresenter = new ActFinalMatch.PresenterBase();
};
ActFinalMatch.PromotePresenter.prototype._clone = function () {
  return new ActFinalMatch.PromotePresenter();
}
ActFinalMatch.PromotePresenter.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.PromotePresenter.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.PromotePresenter.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tJump);
  os.writeStruct(1, this.tPresenter);
};

ActFinalMatch.PromotePresenter.prototype.readFrom = function (is) {
  this.tJump = is.readStruct(0, false, this.tJump);
  this.tPresenter = is.readStruct(1, false, this.tPresenter);
};

ActFinalMatch.PromoteResultPanel = function () {
  this.iPromoteType = 0;
  this.sDesc1 = '';
  this.sDesc2 = '';
  this.iAreaId = 0;
  this.sAreaName = '';
  this.tPresenter = new ActFinalMatch.PromotePresenter();
  this.iStage = 0;
  this.iLogoType = 0;
  this.iRank = 0;
};
ActFinalMatch.PromoteResultPanel.prototype._clone = function () {
  return new ActFinalMatch.PromoteResultPanel();
}
ActFinalMatch.PromoteResultPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.PromoteResultPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.PromoteResultPanel.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iPromoteType);
  os.writeString(1, this.sDesc1);
  os.writeString(2, this.sDesc2);
  os.writeInt32(3, this.iAreaId);
  os.writeString(4, this.sAreaName);
  os.writeStruct(5, this.tPresenter);
  os.writeInt32(6, this.iStage);
  os.writeInt32(7, this.iLogoType);
  os.writeInt32(8, this.iRank);
};

ActFinalMatch.PromoteResultPanel.prototype.readFrom = function (is) {
  this.iPromoteType = is.readInt32(0, false, this.iPromoteType);
  this.sDesc1 = is.readString(1, false, this.sDesc1);
  this.sDesc2 = is.readString(2, false, this.sDesc2);
  this.iAreaId = is.readInt32(3, false, this.iAreaId);
  this.sAreaName = is.readString(4, false, this.sAreaName);
  this.tPresenter = is.readStruct(5, false, this.tPresenter);
  this.iStage = is.readInt32(6, false, this.iStage);
  this.iLogoType = is.readInt32(7, false, this.iLogoType);
  this.iRank = is.readInt32(8, false, this.iRank);
};

ActFinalMatch.ClearPanel = function () {
  this.lPid = 0;
  this.iActivityId = 0;
};
ActFinalMatch.ClearPanel.prototype._clone = function () {
  return new ActFinalMatch.ClearPanel();
}
ActFinalMatch.ClearPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.ClearPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.ClearPanel.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeInt32(1, this.iActivityId);
};

ActFinalMatch.ClearPanel.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.iActivityId = is.readInt32(1, false, this.iActivityId);
};

ActFinalMatch.HonorResultPanel = function () {
  this.iAreaId = 0;
  this.iLogoType = 0;
  this.sAreaName = '';
  this.vWinnerList = new Taf.Vector(new ActFinalMatch.PromotePresenter());
};
ActFinalMatch.HonorResultPanel.prototype._clone = function () {
  return new ActFinalMatch.HonorResultPanel();
}
ActFinalMatch.HonorResultPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.HonorResultPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.HonorResultPanel.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iAreaId);
  os.writeInt32(1, this.iLogoType);
  os.writeString(2, this.sAreaName);
  os.writeVector(3, this.vWinnerList);
};

ActFinalMatch.HonorResultPanel.prototype.readFrom = function (is) {
  this.iAreaId = is.readInt32(0, false, this.iAreaId);
  this.iLogoType = is.readInt32(1, false, this.iLogoType);
  this.sAreaName = is.readString(2, false, this.sAreaName);
  this.vWinnerList = is.readVector(3, false, this.vWinnerList);
};

ActFinalMatch.BattleUser = function () {
  this.lPid = 0;
  this.tJump = new ActFinalMatch.JumpChannel();
  this.sLogoUrl = '';
  this.sNickName = '';
  this.sPortait = '';
};
ActFinalMatch.BattleUser.prototype._clone = function () {
  return new ActFinalMatch.BattleUser();
}
ActFinalMatch.BattleUser.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.BattleUser.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.BattleUser.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeStruct(1, this.tJump);
  os.writeString(2, this.sLogoUrl);
  os.writeString(3, this.sNickName);
  os.writeString(4, this.sPortait);
};

ActFinalMatch.BattleUser.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.tJump = is.readStruct(1, false, this.tJump);
  this.sLogoUrl = is.readString(2, false, this.sLogoUrl);
  this.sNickName = is.readString(3, false, this.sNickName);
  this.sPortait = is.readString(4, false, this.sPortait);
};

ActFinalMatch.BattleUpdatePanel = function () {
  this.lAttScore = 0;
  this.lDefScore = 0;
  this.iLeftTime = 0;
  this.iSide = 0;
  this.iKillTime = 0;
  this.lPid = 0;
};
ActFinalMatch.BattleUpdatePanel.prototype._clone = function () {
  return new ActFinalMatch.BattleUpdatePanel();
}
ActFinalMatch.BattleUpdatePanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.BattleUpdatePanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.BattleUpdatePanel.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lAttScore);
  os.writeInt64(1, this.lDefScore);
  os.writeInt32(2, this.iLeftTime);
  os.writeInt32(3, this.iSide);
  os.writeInt32(4, this.iKillTime);
  os.writeInt64(5, this.lPid);
};

ActFinalMatch.BattleUpdatePanel.prototype.readFrom = function (is) {
  this.lAttScore = is.readInt64(0, false, this.lAttScore);
  this.lDefScore = is.readInt64(1, false, this.lDefScore);
  this.iLeftTime = is.readInt32(2, false, this.iLeftTime);
  this.iSide = is.readInt32(3, false, this.iSide);
  this.iKillTime = is.readInt32(4, false, this.iKillTime);
  this.lPid = is.readInt64(5, false, this.lPid);
};

ActFinalMatch.BattlePanel = function () {
  this.tAttUser = new ActFinalMatch.BattleUser();
  this.tDefUser = new ActFinalMatch.BattleUser();
  this.tUpdate = new ActFinalMatch.BattleUpdatePanel();
  this.iReward = 0;
  this.iAreaId = 0;
  this.iLogoType = 0;
  this.iAssist = 0;
  this.iPkType = 0;
};
ActFinalMatch.BattlePanel.prototype._clone = function () {
  return new ActFinalMatch.BattlePanel();
}
ActFinalMatch.BattlePanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.BattlePanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.BattlePanel.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tAttUser);
  os.writeStruct(1, this.tDefUser);
  os.writeStruct(2, this.tUpdate);
  os.writeInt32(3, this.iReward);
  os.writeInt32(4, this.iAreaId);
  os.writeInt32(5, this.iLogoType);
  os.writeInt32(6, this.iAssist);
  os.writeInt32(7, this.iPkType);
};

ActFinalMatch.BattlePanel.prototype.readFrom = function (is) {
  this.tAttUser = is.readStruct(0, false, this.tAttUser);
  this.tDefUser = is.readStruct(1, false, this.tDefUser);
  this.tUpdate = is.readStruct(2, false, this.tUpdate);
  this.iReward = is.readInt32(3, false, this.iReward);
  this.iAreaId = is.readInt32(4, false, this.iAreaId);
  this.iLogoType = is.readInt32(5, false, this.iLogoType);
  this.iAssist = is.readInt32(6, false, this.iAssist);
  this.iPkType = is.readInt32(7, false, this.iPkType);
};

ActFinalMatch.BattleAnnouncePanel = function () {
  this.tBattle = new ActFinalMatch.BattlePanel();
};
ActFinalMatch.BattleAnnouncePanel.prototype._clone = function () {
  return new ActFinalMatch.BattleAnnouncePanel();
}
ActFinalMatch.BattleAnnouncePanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.BattleAnnouncePanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.BattleAnnouncePanel.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tBattle);
};

ActFinalMatch.BattleAnnouncePanel.prototype.readFrom = function (is) {
  this.tBattle = is.readStruct(0, false, this.tBattle);
};

ActFinalMatch.BattleResultPanel = function () {
  this.tBattle = new ActFinalMatch.BattlePanel();
  this.lDeltaScore = 0;
  this.iResult = 0;
  this.lPresentScore = 0;
};
ActFinalMatch.BattleResultPanel.prototype._clone = function () {
  return new ActFinalMatch.BattleResultPanel();
}
ActFinalMatch.BattleResultPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.BattleResultPanel.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.BattleResultPanel.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tBattle);
  os.writeInt64(1, this.lDeltaScore);
  os.writeInt32(2, this.iResult);
  os.writeInt64(3, this.lPresentScore);
};

ActFinalMatch.BattleResultPanel.prototype.readFrom = function (is) {
  this.tBattle = is.readStruct(0, false, this.tBattle);
  this.lDeltaScore = is.readInt64(1, false, this.lDeltaScore);
  this.iResult = is.readInt32(2, false, this.iResult);
  this.lPresentScore = is.readInt64(3, false, this.lPresentScore);
};

ActFinalMatch.ContributionRankItem = function () {
  this.lUid = 0;
  this.lScore = 0;
  this.sNickName = '';
  this.sLogoURL = '';
};
ActFinalMatch.ContributionRankItem.prototype._clone = function () {
  return new ActFinalMatch.ContributionRankItem();
}
ActFinalMatch.ContributionRankItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.ContributionRankItem.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.ContributionRankItem.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeInt64(1, this.lScore);
  os.writeString(2, this.sNickName);
  os.writeString(3, this.sLogoURL);
};

ActFinalMatch.ContributionRankItem.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.lScore = is.readInt64(1, false, this.lScore);
  this.sNickName = is.readString(2, false, this.sNickName);
  this.sLogoURL = is.readString(3, false, this.sLogoURL);
};

ActFinalMatch.ContributionRank = function () {
  this.vAttRank = new Taf.Vector(new ActFinalMatch.ContributionRankItem());
  this.vDefRank = new Taf.Vector(new ActFinalMatch.ContributionRankItem());
  this.lPid = 0;
};
ActFinalMatch.ContributionRank.prototype._clone = function () {
  return new ActFinalMatch.ContributionRank();
}
ActFinalMatch.ContributionRank.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.ContributionRank.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.ContributionRank.prototype.writeTo = function (os) {
  os.writeVector(0, this.vAttRank);
  os.writeVector(1, this.vDefRank);
  os.writeInt64(2, this.lPid);
};

ActFinalMatch.ContributionRank.prototype.readFrom = function (is) {
  this.vAttRank = is.readVector(0, false, this.vAttRank);
  this.vDefRank = is.readVector(1, false, this.vDefRank);
  this.lPid = is.readInt64(2, false, this.lPid);
};

ActFinalMatch.AssistRankItem = function () {
  this.tJump = new ActFinalMatch.JumpChannel();
  this.sNickName = '';
  this.sLogoURL = '';
  this.iRoleType = 0;
  this.lScore = 0;
};
ActFinalMatch.AssistRankItem.prototype._clone = function () {
  return new ActFinalMatch.AssistRankItem();
}
ActFinalMatch.AssistRankItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.AssistRankItem.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.AssistRankItem.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tJump);
  os.writeString(1, this.sNickName);
  os.writeString(2, this.sLogoURL);
  os.writeInt32(3, this.iRoleType);
  os.writeInt64(4, this.lScore);
};

ActFinalMatch.AssistRankItem.prototype.readFrom = function (is) {
  this.tJump = is.readStruct(0, false, this.tJump);
  this.sNickName = is.readString(1, false, this.sNickName);
  this.sLogoURL = is.readString(2, false, this.sLogoURL);
  this.iRoleType = is.readInt32(3, false, this.iRoleType);
  this.lScore = is.readInt64(4, false, this.lScore);
};

ActFinalMatch.BattleAssistRank = function () {
  this.vAttRank = new Taf.Vector(new ActFinalMatch.AssistRankItem());
  this.vDefRank = new Taf.Vector(new ActFinalMatch.AssistRankItem());
  this.lPid = 0;
};
ActFinalMatch.BattleAssistRank.prototype._clone = function () {
  return new ActFinalMatch.BattleAssistRank();
}
ActFinalMatch.BattleAssistRank.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.BattleAssistRank.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.BattleAssistRank.prototype.writeTo = function (os) {
  os.writeVector(0, this.vAttRank);
  os.writeVector(1, this.vDefRank);
  os.writeInt64(2, this.lPid);
};

ActFinalMatch.BattleAssistRank.prototype.readFrom = function (is) {
  this.vAttRank = is.readVector(0, false, this.vAttRank);
  this.vDefRank = is.readVector(1, false, this.vDefRank);
  this.lPid = is.readInt64(2, false, this.lPid);
};

ActFinalMatch.StageInfoReq = function () {
  this.lPid = 0;
  this.iAreaId = 0;
};
ActFinalMatch.StageInfoReq.prototype._clone = function () {
  return new ActFinalMatch.StageInfoReq();
}
ActFinalMatch.StageInfoReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.StageInfoReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.StageInfoReq.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeInt32(1, this.iAreaId);
};

ActFinalMatch.StageInfoReq.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.iAreaId = is.readInt32(1, false, this.iAreaId);
};

ActFinalMatch.StageInfoRsp = function () {
  this.iAreaId = 0;
  this.iStage = 0;
  this.iDay = 0;
  this.iTotalDay = 0;
};
ActFinalMatch.StageInfoRsp.prototype._clone = function () {
  return new ActFinalMatch.StageInfoRsp();
}
ActFinalMatch.StageInfoRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.StageInfoRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.StageInfoRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iAreaId);
  os.writeInt32(1, this.iStage);
  os.writeInt32(2, this.iDay);
  os.writeInt32(3, this.iTotalDay);
};

ActFinalMatch.StageInfoRsp.prototype.readFrom = function (is) {
  this.iAreaId = is.readInt32(0, false, this.iAreaId);
  this.iStage = is.readInt32(1, false, this.iStage);
  this.iDay = is.readInt32(2, false, this.iDay);
  this.iTotalDay = is.readInt32(3, false, this.iTotalDay);
};

ActFinalMatch.HourRankReq = function () {
  this.iArea = 0;
  this.iStage = 0;
  this.lPid = 0;
};
ActFinalMatch.HourRankReq.prototype._clone = function () {
  return new ActFinalMatch.HourRankReq();
}
ActFinalMatch.HourRankReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.HourRankReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.HourRankReq.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iArea);
  os.writeInt32(1, this.iStage);
  os.writeInt64(2, this.lPid);
};

ActFinalMatch.HourRankReq.prototype.readFrom = function (is) {
  this.iArea = is.readInt32(0, false, this.iArea);
  this.iStage = is.readInt32(1, false, this.iStage);
  this.lPid = is.readInt64(2, false, this.lPid);
};

ActFinalMatch.HourChampionItem = function () {
  this.tItem = new ActFinalMatch.RankItem();
  this.iBegHour = 0;
  this.iEndHour = 0;
  this.iTheme = 0;
};
ActFinalMatch.HourChampionItem.prototype._clone = function () {
  return new ActFinalMatch.HourChampionItem();
}
ActFinalMatch.HourChampionItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.HourChampionItem.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.HourChampionItem.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tItem);
  os.writeInt32(1, this.iBegHour);
  os.writeInt32(2, this.iEndHour);
  os.writeInt32(3, this.iTheme);
};

ActFinalMatch.HourChampionItem.prototype.readFrom = function (is) {
  this.tItem = is.readStruct(0, false, this.tItem);
  this.iBegHour = is.readInt32(1, false, this.iBegHour);
  this.iEndHour = is.readInt32(2, false, this.iEndHour);
  this.iTheme = is.readInt32(3, false, this.iTheme);
};

ActFinalMatch.HourChampionRsp = function () {
  this.vRank = new Taf.Vector(new ActFinalMatch.HourChampionItem());
};
ActFinalMatch.HourChampionRsp.prototype._clone = function () {
  return new ActFinalMatch.HourChampionRsp();
}
ActFinalMatch.HourChampionRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.HourChampionRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.HourChampionRsp.prototype.writeTo = function (os) {
  os.writeVector(0, this.vRank);
};

ActFinalMatch.HourChampionRsp.prototype.readFrom = function (is) {
  this.vRank = is.readVector(0, false, this.vRank);
};

ActFinalMatch.TotalRankReq = function () {
  this.iArea = 0;
  this.iStage = 0;
  this.lPid = 0;
};
ActFinalMatch.TotalRankReq.prototype._clone = function () {
  return new ActFinalMatch.TotalRankReq();
}
ActFinalMatch.TotalRankReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.TotalRankReq.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.TotalRankReq.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iArea);
  os.writeInt32(1, this.iStage);
  os.writeInt64(2, this.lPid);
};

ActFinalMatch.TotalRankReq.prototype.readFrom = function (is) {
  this.iArea = is.readInt32(0, false, this.iArea);
  this.iStage = is.readInt32(1, false, this.iStage);
  this.lPid = is.readInt64(2, false, this.lPid);
};

ActFinalMatch.TotalRankRsp = function () {
  this.vRank = new Taf.Vector(new ActFinalMatch.RankItem());
  this.iStage = 0;
  this.iArea = 0;
  this.sStageTips = '';
};
ActFinalMatch.TotalRankRsp.prototype._clone = function () {
  return new ActFinalMatch.TotalRankRsp();
}
ActFinalMatch.TotalRankRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
}
ActFinalMatch.TotalRankRsp.prototype._read  = function (is, tag, def) {
  return is.readStruct(tag, true, def);
}

ActFinalMatch.TotalRankRsp.prototype.writeTo = function (os) {
  os.writeVector(0, this.vRank);
  os.writeInt32(1, this.iStage);
  os.writeInt32(2, this.iArea);
  os.writeString(3, this.sStageTips);
};

ActFinalMatch.TotalRankRsp.prototype.readFrom = function (is) {
  this.vRank = is.readVector(0, false, this.vRank);
  this.iStage = is.readInt32(1, false, this.iStage);
  this.iArea = is.readInt32(2, false, this.iArea);
  this.sStageTips = is.readString(3, false, this.sStageTips);
};

export default ActFinalMatch;
